import CandidateProfile from "./CandidateProfile";
const ViewPofile = () => {
  return (
    <>
      <CandidateProfile />
    </>
  );
};
export default ViewPofile;
